var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e;
import { Vue, Component, Prop, Watch, } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { SystemComponentTreeNodesClient, ComponentsClient, ModelsClient, ManufacturersClient, SystemComponentsClient, LookupsClient, GetSystemComponentTreeQuery, UpdateSystemComponentCommand, UpdateComponentDatesCommand, SystemComponentTreeModel, ComponentModel, SystemComponentModel, SystemComponentQueryModel, ComponentTypeEnum, ManufacturerTypeEnum } from "@/app/api/battery-portal-api";
import { LoginState } from "@/app/store/modules/login.state";
import ComponentTreeVue from "@/app/vues/shared/component-tree.vue";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { ArrayHelper } from "@/app/utils/array-helper";
import { DateHelper } from "@/app/utils/date-helper";
import moment from 'moment';
const systemComponentTreeNodesClient = new SystemComponentTreeNodesClient(window.apiUrl);
const componentsClient = new ComponentsClient(window.apiUrl);
const modelClient = new ModelsClient(window.apiUrl);
const manufacturerClient = new ManufacturersClient(window.apiUrl);
const systemComponentClient = new SystemComponentsClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
let SystemManagementVue = class SystemManagementVue extends Vue {
    constructor() {
        super(...arguments);
        this.manufacturers = [];
        this.models = [];
        // simpletons
        this.treeLoaded = false;
        this.working = false;
        this.editingComponent = false;
        this.manufactureDate = null;
        this.replacementDate = null;
        this.manufacturer = null;
        this.model = null;
        this.settingManufacture = false;
        this.settingReplacement = false;
        this.settingManufacturerAndModel = false;
        this.editingString = false;
        this.selectedString = new SystemComponentQueryModel();
        this.whenInstalled = null;
        this.whenNextReplacement = null;
        this.replicateBlockTargetFloatVoltage = false;
        // components
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        // models
        // NOTE: systemId is assigned in created() because with vue-facing-decorator v4
        // class field initializers run before @Prop values are bound on the instance,
        // so `this.systemId` is undefined here.
        this.componentTreeQuery = new GetSystemComponentTreeQuery({
            systemId: null,
            includeDeleted: false,
            includeOrphans: true
        });
        this.componentTree = new SystemComponentTreeModel();
        this.selectedComponentTreeNodes = new Array();
    }
    created() {
        try {
            this.componentTreeQuery.systemId = this.systemId;
            this.getComponentTree();
        }
        catch (e) {
            console.error('error creating system management', e);
        }
    }
    ;
    getComponentTree() {
        this.treeLoaded = false;
        if (!this.systemId) {
            let componentTree = new SystemComponentTreeModel();
            componentTree.init({});
            this.componentTree = componentTree;
            this.treeLoaded = true;
            return;
        }
        ;
        systemComponentTreeNodesClient
            .getStringsAndBlocks(this.systemId)
            .then(response => {
            this.componentTree = this.filterOnlyStringsAndBlocks(response);
            this.treeLoaded = true;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    filterOnlyStringsAndBlocks(tree) {
        if (!(tree === null || tree === void 0 ? void 0 : tree.children))
            return;
        try {
            var toRemove = [];
            tree.children.forEach(node => {
                if (node.componentTypeId != ComponentTypeEnum.String && node.componentTypeId != ComponentTypeEnum.Block)
                    toRemove.push(node);
                if (node.children)
                    this.filterOnlyStringsAndBlocks(node);
            });
            toRemove.forEach(node => {
                let index = tree.children.indexOf(node, 0);
                if (index > -1) {
                    tree.children.splice(index, 1);
                }
            });
            return tree;
        }
        catch (e) {
            console.error(e);
        }
    }
    onManufacturerChanged(newVal, oldVal) {
        if (this.settingManufacturerAndModel && (newVal === null || newVal === void 0 ? void 0 : newVal.value) != (oldVal === null || oldVal === void 0 ? void 0 : oldVal.value)) {
            this.model = null;
        }
    }
    onSelectedStringManufacturerChanged(newVal, oldVal) {
        if (this.editingString && oldVal && newVal != oldVal) {
            this.selectedString.modelId = null;
        }
    }
    // computed
    get loaded() {
        return this.treeLoaded;
    }
    ;
    getDateFormatted(date) {
        if (!date)
            return 'not defined';
        var now = moment();
        var target = moment(date);
        var isFuture = target.isAfter(now);
        var a = isFuture ? target : now;
        var b = isFuture ? now : target;
        var years = a.diff(b, 'year');
        b.add(years, 'years');
        var months = a.diff(b, 'months');
        b.add(months, 'months');
        var age = `${months} mth${months !== 1 ? 's' : ''}`;
        if (years > 0)
            age = months > 0 ? `${years} yr${years !== 1 ? 's' : ''} ` + age : `${years} yr${years !== 1 ? 's' : ''}`;
        var suffix = isFuture ? 'from now' : 'ago';
        return `${DateHelper.convertToFriendlyMomentDateString(date)} (${age} ${suffix})`;
    }
    isString(componentTypeId) {
        return componentTypeId == ComponentTypeEnum.String;
    }
    isBlock(componentTypeId) {
        return componentTypeId == ComponentTypeEnum.Block;
    }
    nodeSelectionChanged(request) {
        let item = request.item;
        let idx = ArrayHelper.findFirstIndex(this.selectedComponentTreeNodes, (filter) => {
            return filter == item.componentId;
        });
        if (idx < 0) {
            this.selectedComponentTreeNodes.push(item.componentId);
        }
        else
            this.selectedComponentTreeNodes.splice(idx, 1);
    }
    ;
    setManufactureDate() {
        this.settingManufacture = true;
    }
    setReplacmentDate() {
        var _a, _b;
        if (this.selectedComponentTreeNodes.length == 1) {
            let selectedBlock = null;
            (_b = (_a = this.componentTree) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.forEach(string => {
                selectedBlock = selectedBlock !== null && selectedBlock !== void 0 ? selectedBlock : string.children.find(block => block.componentId == this.selectedComponentTreeNodes[0]);
            });
            if (selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.whenManufactured)
                this.manufactureDate = selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.whenManufactured;
        }
        this.settingManufacture = true;
        this.settingReplacement = true;
    }
    setManufactorerAndModel() {
        this.manufacturer = null;
        this.model = null;
        this.settingManufacturerAndModel = true;
    }
    hasSelection() {
        return this.selectedComponentTreeNodes.length > 0;
    }
    hasStringSelection() {
        var _a, _b, _c;
        if (this.selectedComponentTreeNodes.length === 0)
            return false;
        return (_c = (_b = (_a = this.componentTree) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.some(string => string.componentTypeId === ComponentTypeEnum.String &&
            this.selectedComponentTreeNodes.includes(string.componentId))) !== null && _c !== void 0 ? _c : false;
    }
    settingValues() {
        return this.settingManufacture || this.settingReplacement || this.settingManufacturerAndModel;
    }
    updateManufactorAndModel() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (this.settingManufacturerAndModel && (this.manufacturer == null || this.model == null)) {
                Notifier.onWarning(`Please inform the manufacturer and model.`);
                return;
            }
            var strings = [];
            this.selectedComponentTreeNodes.forEach(componentId => {
                var component = this.componentTree.children.find(item => item.componentId == componentId);
                if (component && component.componentTypeId == ComponentTypeEnum.String) {
                    strings.push(component);
                }
            });
            if (!strings.length) {
                Notifier.onWarning(`No Strings are selected.`);
                return;
            }
            this.working = true;
            var promises = [];
            for (var idx = 0; idx < strings.length; idx++) {
                this.selectedString = strings[idx];
                this.selectedString.manufacturerId = this.manufacturer.value;
                this.selectedString.modelId = this.model.modelId;
                if (idx == 0 && strings.length > 1 && (((_a = this.manufacturer) === null || _a === void 0 ? void 0 : _a.value) == 0 || ((_b = this.model) === null || _b === void 0 ? void 0 : _b.modelId) == 0)) {
                    yield this.updateString();
                }
                promises.push(this.updateString());
            }
            //strings.forEach(currentString, idx => {
            //	this.selectedString = currentString;
            //	this.selectedString.manufacturerId = this.manufacturer.value;
            //	this.selectedString.modelId = this.model.modelId;
            //	var promise = this.updateString();
            //	if (idx == 0 && (this.manufacturer?.value == 0 || this.model?.modelId == 0)) {
            //	}
            //	promises.push(promise);
            //});
            Promise.all(promises)
                .then(response => {
                if (!response)
                    return;
                // re-load manufactures in case any had been added
                if (this.selectedString.manufacturerId == 0 || this.selectedString.modelId == 0) {
                    this.$emit("onReloadManufacturerAndModel");
                }
                Notifier.onOk("String(s) has been successfully updated.");
            }).
                catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.selectedString = new SystemComponentQueryModel();
                this.settingManufacturerAndModel = false;
                this.editingString = false;
                this.getComponentTree();
            });
        });
    }
    update() {
        if (this.settingManufacturerAndModel) {
            this.updateManufactorAndModel();
            return;
        }
        var components = [];
        if (this.selectedComponentTreeNodes.length == 0) {
            Notifier.onWarning(`Please select components.`);
            return;
        }
        if (!this.manufactureDate || (this.settingReplacement && !this.replacementDate)) {
            Notifier.onWarning(`Please select a date.`);
            return;
        }
        let manufacturedOn = DateHelper.convertToDate(this.manufactureDate);
        let replacedOn = DateHelper.convertToDate(this.replacementDate);
        if (manufacturedOn > new Date()) {
            Notifier.onWarning(`Manufactured date cannot be in the future.`);
            return;
        }
        if (this.settingReplacement && replacedOn > new Date()) {
            Notifier.onWarning(`Replaced date cannot be in the future.`);
            return;
        }
        if (this.settingReplacement && manufacturedOn >= replacedOn) {
            Notifier.onWarning(`Manufactured date cannot be greater or equal than the replacement date.`);
            return;
        }
        this.selectedComponentTreeNodes.forEach(componentId => {
            var model = new ComponentModel();
            model.componentId = componentId;
            model.whenManufactured = manufacturedOn;
            model.whenLastReplacement = this.settingReplacement ? replacedOn : null;
            components.push(model);
        });
        if (components.length == 0) {
            this.cancel();
            return;
        }
        var command = new UpdateComponentDatesCommand({
            components: components,
            timezoneOffset: moment().utcOffset()
        });
        componentsClient
            .updateComponentDates(command)
            .then(() => {
            this.getComponentTree();
            Notifier.onOk();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.initDates();
        });
    }
    cancel() {
        this.initDates();
        this.manufacturer = null;
        this.model = null;
        this.settingManufacturerAndModel = false;
    }
    initDates() {
        this.manufactureDate = null;
        this.replacementDate = null;
        this.settingManufacture = false;
        this.settingReplacement = false;
    }
    editString(componentId) {
        this.settingManufacturerAndModel = false;
        this.settingManufacture = false;
        this.settingReplacement = false;
        this.selectedString = this.componentTree.children.find(item => item.componentId == componentId);
        this.whenInstalled = this.selectedString.whenInstalled;
        this.whenNextReplacement = this.selectedString.whenNextReplacement;
        this.editingString = this.selectedString !== undefined;
    }
    ;
    /**
     * Save selected string's details
     * */
    saveString() {
        var _a;
        if (this.working)
            return;
        if (!this.selectedString)
            return;
        if (this.whenInstalled) {
            var installedOn = DateHelper.convertToDate(this.whenInstalled);
            if (installedOn > new Date()) {
                Notifier.onWarning(`Install date cannot be in the future.`);
                return;
            }
        }
        if (this.whenNextReplacement) {
            var whenNextReplacement = DateHelper.convertToDate(this.whenNextReplacement);
            if (whenNextReplacement <= new Date()) {
                Notifier.onWarning(`Next replacement date cannot be in the past.`);
                return;
            }
        }
        if (this.selectedString.blockTargetFloatVoltage) {
            var blockTargetFloatVoltage = Number(this.selectedString.blockTargetFloatVoltage);
            if (blockTargetFloatVoltage == NaN || blockTargetFloatVoltage <= 0 || blockTargetFloatVoltage > 1000) {
                Notifier.onWarning(`Enter a valid value between 0.1 and 1000 for the Block Target Float Voltage field.`);
                return;
            }
        }
        this.working = true;
        var currentString = this.selectedString;
        var promises = [this.updateString()];
        if (this.replicateBlockTargetFloatVoltage) {
            this.replicateBlockTargetFloatVoltage = false;
            (_a = this.componentTree.children) === null || _a === void 0 ? void 0 : _a.forEach(stringComponent => {
                if (currentString.componentId != stringComponent.componentId) {
                    this.selectedString = stringComponent;
                    this.selectedString.blockTargetFloatVoltage = currentString.blockTargetFloatVoltage;
                    promises.push(this.updateString());
                }
            });
        }
        Promise.all(promises)
            .then(response => {
            if (!response)
                return;
            // re-load manufactures in case any had been added
            if (this.selectedString.manufacturerId == 0 || this.selectedString.modelId == 0) {
                this.$emit("onReloadManufacturerAndModel");
            }
            Notifier.onOk("String has been successfully updated.");
        }).
            catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.selectedString = new SystemComponentQueryModel();
            this.editingString = false;
            this.getComponentTree();
        });
    }
    ;
    updateString() {
        let systemComponent = new SystemComponentModel();
        systemComponent.systemId = this.selectedString.systemId;
        systemComponent.componentId = this.selectedString.componentId;
        systemComponent.statusId = this.selectedString.statusId;
        systemComponent.whenInstalled = this.whenInstalled
            ? DateHelper.convertToDate(this.whenInstalled.toString()) : null;
        systemComponent.component = new ComponentModel();
        systemComponent.component.componentId = this.selectedString.componentId;
        systemComponent.component.manufacturerId = this.selectedString.manufacturerId;
        systemComponent.component.modelId = this.selectedString.modelId;
        systemComponent.component.blockTargetFloatVoltage = this.selectedString.blockTargetFloatVoltage;
        systemComponent.component.whenNextReplacement = this.whenNextReplacement
            ? DateHelper.convertToDate(this.whenNextReplacement.toString()) : null;
        let model = this.stringModel;
        if (model)
            systemComponent.component.modelName = model.modelName;
        let manufacturer = this.stringManufacturer;
        if (manufacturer && manufacturer.text != this.selectPlaceholder)
            systemComponent.component.manufacturerName = manufacturer.text;
        let command = new UpdateSystemComponentCommand({
            requestModel: systemComponent
        });
        return systemComponentClient.update(command);
    }
    closeString() {
        this.selectedString = new SystemComponentQueryModel();
        this.editingString = false;
    }
    ;
    addStringManufacturer(option) {
        var setStringManufacturer = (manufacturer) => {
            var item = this.batteryManufacturers.find(item => item.value == manufacturer.manufacturerId);
            if (this.settingManufacturerAndModel)
                this.manufacturer = item;
            else
                this.stringManufacturer = item;
        };
        this.$emit('onAddStringManufacturer', option, setStringManufacturer);
    }
    ;
    addStringModel(option) {
        var _a, _b;
        var manufacturerId = this.settingManufacturerAndModel ? (_a = this.manufacturer) === null || _a === void 0 ? void 0 : _a.value : (_b = this.stringManufacturer) === null || _b === void 0 ? void 0 : _b.value;
        if (!manufacturerId && manufacturerId != 0) {
            Notifier.onWarning("Please select a manufacturer first.");
            return;
        }
        var setStringModel = (model) => {
            if (this.settingManufacturerAndModel)
                this.model = model;
            else
                this.stringModel = model;
        };
        this.$emit('onAddStringModel', manufacturerId, option, setStringModel);
    }
    ;
    deleteManufacturer(item) {
        this.$emit('onDeleteStringManufacturer', item);
    }
    ;
    deleteControllerModel(item) {
        this.$emit('onDeleteStringModel', item);
    }
    ;
    get batteryManufacturers() {
        return (this.manufacturers || [])
            .filter(item => item.manufacturerTypeId == ManufacturerTypeEnum.Battery)
            .map((item) => {
            return {
                value: item.manufacturerId,
                text: item.manufacturerName || ""
            };
        });
    }
    get stringManufacturer() {
        return this.batteryManufacturers.filter(item => {
            return (item.value == this.selectedString.manufacturerId);
        })[0] || null;
    }
    ;
    set stringManufacturer(item) {
        var _a;
        this.selectedString.manufacturerId = (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : null;
    }
    ;
    get stringModel() {
        return this.models.filter(item => item.modelId == this.selectedString.modelId)[0] || null;
    }
    ;
    set stringModel(item) {
        if (!item)
            return;
        this.selectedString.modelId = item.modelId;
    }
    ;
    get isClientInstaller() {
        return this.loginState.isClientInstaller;
    }
    ;
    get isClient() {
        return !this.loginState.isClientInstaller;
    }
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get stringModels() {
        var _a, _b;
        var manufacturerId = this.settingManufacturerAndModel ? (_a = this.manufacturer) === null || _a === void 0 ? void 0 : _a.value : (_b = this.stringManufacturer) === null || _b === void 0 ? void 0 : _b.value;
        if (!manufacturerId)
            return [];
        return this.models.filter(model => model.modelId == this.selectedString.modelId
            || (model.componentTypeId == ComponentTypeEnum.String && model.manufacturerId == manufacturerId));
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], SystemManagementVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], SystemManagementVue.prototype, "systemId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], SystemManagementVue.prototype, "companyId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
], SystemManagementVue.prototype, "manufacturers", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_c = typeof Array !== "undefined" && Array) === "function" ? _c : Object)
], SystemManagementVue.prototype, "models", void 0);
__decorate([
    Watch("manufacturer"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SystemManagementVue.prototype, "onManufacturerChanged", null);
__decorate([
    Watch("selectedString.manufacturerId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], SystemManagementVue.prototype, "onSelectedStringManufacturerChanged", null);
SystemManagementVue = __decorate([
    Component({
        name: "SystemManagementVue",
        emits: ["onAddStringManufacturer", "onDeleteStringManufacturer", "onAddStringModel", "onDeleteStringModel", "onReloadManufacturerAndModel"],
        expose: ["getComponentTree"],
        components: {
            ComponentTreeVue
        },
    })
], SystemManagementVue);
export default SystemManagementVue;
